<template>
  <LkPage />
</template>

<script>
import LkPage from '@/components/pages/LkPage.vue';

export default {
  name: 'LkView',
  components: {
    LkPage,
  },
};
</script>
